import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import _ from 'lodash';
import AdvertWrapper from 'modules/Common/components/AdvertWrapper';

import Table from 'modules/Common/components/Table';
import { LocalFullDate } from 'modules/Common/components/LocalDateTime';

export default class FootballMatchTable extends Component {
  static propTypes = {
    matchLabel: PropTypes.string,
    tables: PropTypes.array.isRequired,
    match: PropTypes.object
  }

  createLeagueTables(tables) {
    return tables.map((table, key) => {
      return (
        <section key={key} className="football-match-table-section">
        { table.label &&
          <header>
            <h2>{table.label}</h2>
          </header>
        }
          <Table row={table.row}/>
        </section>
      )
    })
  }

  render() {
    require('./FootballMatchTable.scss');

    if (!this.props.tables || this.props.tables.length == 0) {
      return (
        <div className="default-no-article">
          <p>We are currently unable to show the table.</p>
        </div>
      );
    } 

    const matchName = _.get(this.props, 'match.competition.name');
    return (
      <div className="footballMatchTable">
        <MetaDataWrapper title={`${this.props.matchLabel} - Table`}/>
        <h3 className="competition-name section-title">{matchName}</h3>
        <h4 className="table-date section-subtitle"><LocalFullDate iso={new Date}/></h4>
        { this.createLeagueTables(this.props.tables) }
        <AdvertWrapper ocSlot={["football", "leaderboard"]} additionalProperties={{view: "live"}} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Football/components/FootballMatchTable.js